import {
  ORG_SECTION_STRUCTURE_EXPLANATION_CONTEXT,
  ORG_VIEW_EXPLANATION_CONTEXT,
  selectSectionListContext,
} from "./org-context";
import { selectCurrentOrgOutcomeContext, selectPageOutcomeContext } from "./outcome-context";
import { PAGE_EXPLANATION_CONTEXT, selectPageMetadataContext } from "./page-context";
import { ACTIVITY_EXPLANATION_CONTEXT, TOPIC_EXPLANATION_CONTEXT } from "./section-context";

import { createAppSelector, pageSelectors } from "store/selectors";

/**
 * Information available on the org page should be:
 * - All sections, with their term and code
 * - An explanation of what sections, terms, and courses are
 * - All outcomes in the org, and their rubric
 *
 * For any actions the user asks about, relevant documentation from Gitbook will
 * hopefully be injected through RAG in the backend.
 *
 * TODO: Adapt this to new home page, which can be viewed by non-admins
 */
export const selectHomeContextForAi = createAppSelector(
  [selectSectionListContext, selectCurrentOrgOutcomeContext],
  (sectionListContext, currentOrgOutcomeContext) =>
    [
      ORG_VIEW_EXPLANATION_CONTEXT,
      ORG_SECTION_STRUCTURE_EXPLANATION_CONTEXT,
      sectionListContext,
      currentOrgOutcomeContext,
    ].join("\n"),
);

export const selectPageContextForAi = createAppSelector(
  [pageSelectors.selectById, selectPageMetadataContext, selectPageOutcomeContext],
  (page, pageMetadataContext, pageOutcomeContext) => {
    if (!page) {
      return "";
    }
    return [pageMetadataContext, pageOutcomeContext].filter(Boolean).join("\n");
  },
);

export const CONTENT_TYPE_EXPLANATIONS = [
  TOPIC_EXPLANATION_CONTEXT,
  ACTIVITY_EXPLANATION_CONTEXT,
  PAGE_EXPLANATION_CONTEXT,
].join("\n");
